
/**
 * @returns {Boolean} `true` when application in full-screen, `false` otherwise.
 */
export const isFullScreen = () => {
  return !!document.fullscreenElement || !!document.webkitFullscreenElement;
}

export default isFullScreen;